import Box, { type BoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const CarTileMedia = styled(Box)<BoxProps>(() => ({
  position: 'relative',

  '.kmx-car-tile--unavailable & .MuiCardMedia-root': {
    opacity: 0.5,
  },
}));

export default CarTileMedia;
